import React from "react";

export default function LoadingScreen() {
  return (
    <div className="loading-screen" role="status" aria-live="polite">
      <div className="loading-spinner" />
      <span className="loading-text">cultivando…</span>
    </div>
  );
}
